<template>
    <div v-if="domain.includes('docuxtract.docunecta.com')" class='white_dns'>
        <v-card
            width="400" 
            class="mx-auto rounded-xl py-6 px-8 deep-purple lighten-5 signup__form__card"
            elevation="3"
            :class="$vuetify.breakpoint.mdAndUp ? 'mt-5' : ''"
        >
            <v-card-title class="primary--text text-center">
                <p>
                    <b>
                        Cambiar contraseña
                    </b>
                </p>
            </v-card-title>
            <v-card-text class="pb-0" v-if="!success"> 
                <v-form id="password-reset-form">
                    <v-text-field
                        outlined
                        :type="showPassword ? 'text' : 'password'"
                        label="Nueva Contraseña"
                        background-color="#FFFFFF"    
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        v-model="password"
                        @click:append="showPassword = !showPassword"
                        v-on:keyup.enter="passwordResetKey"
                    />
                    <v-text-field
                        outlined
                        :type="showPassword2 ? 'text' : 'password'"
                        label="Repetir Contraseña"
                        background-color="#FFFFFF"    
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                        v-model="password2"
                        @click:append="showPassword2 = !showPassword2"
                        v-on:keyup.enter="passwordResetKey"
                    />
                    <p v-if="error" class="red--text">{{error}}</p>
                </v-form>
            </v-card-text>                                                
            <v-card-actions class="justify-center my-2 py-0" v-if="!success">
                <v-btn large class="px-4 mb-2 primary--text font-weight-bold" color="#FCED4F" :loading='loading' @click="passwordResetKey">
                    Cambiar Contraseña
                </v-btn>
            </v-card-actions>
            <v-card-text v-if="success">
                <strong>Contraseña cambiada con éxito.</strong>
            </v-card-text>
            <v-card-actions class="justify-center my-2 py-0">
                <router-link :to="{ name: 'login' }">
                    Inicia sesión 
                </router-link>
                &nbsp;con tus credenciales 
            </v-card-actions>
        </v-card>
    </div>
    <div v-else>
        <app-header-public :transparentHeader="false"/>
        <section>
            <v-container 
                fluid 
                class="fill-height pb-16"
                :class="$vuetify.breakpoint.lgAndUp ? 'signup__background' : ''"
            >
                <v-row align="center" justify="space-around">
                    <v-col lg="6" xl="5" sm="12" xs="12" md="6">
                        <v-row justify="center">
                            <v-col :cols="$vuetify.breakpoint.lgAndUp ? 8:12" >
                                <v-container :fluid="true" :class="{ 'text-center mt-12': $vuetify.breakpoint.smAndDown }">
                                    <div :class="{ 'mx-12': $vuetify.breakpoint.sm }">
                                        <v-img v-if="$vuetify.breakpoint.mdAndUp" src="/logo-primary.png" max-width="162px" class="mb-12" />
                                        <p class="text-h6 text-uppercase primary--text">Contabilidad automatizada</p>
                                        <h1 :class="{'text-h3':$vuetify.breakpoint.mdAndUp,'text-h5':$vuetify.breakpoint.smAndDown}" class="primary--text font-weight-bold mt-5 mb-3">
                                            ¡Hola! Soy Inmatic. Tu robot contable.
                                        </h1>
                                        <p class="mb-2 grey--text text--darken-3">
                                            Descubre como liberar la carga de trabajo y el tiempo que te requiere picar facturas
                                            de forma simple y ágil.
                                        </p>
                                        <h2 class="mb-2">¿Qué consigues con nuestra prueba gratuita?</h2>
                                        <ul class="mb-3 grey--text text--darken-3">
                                            <li>
                                                Aprovecha una solución basada en inteligencia artificial para reducir a la mitad el
                                                tiempo de contabilización de tus facturas.
                                            </li>
                                            <li>
                                                Aumenta la eficacia de tu gestoría creando un modelo de trabajo escalable.
                                            </li>
                                            <li>
                                                Motoriza de principio a fin el proceso contable.
                                            </li>
                                        </ul>
                                    </div>
                                </v-container>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col 
                        :order="$vuetify.breakpoint.mdAndUp ? '' : 'first'" 
                        lg="6" xl="5" sm="12" xs="12" md="6" 
                        class="signup__form__column"
                    >
                        <div :class="{'mx-5':$vuetify.breakpoint.mdAndDown}">
                            <v-card
                                width="400" 
                                class="mx-auto rounded-xl py-6 px-8 deep-purple lighten-5 signup__form__card"
                                elevation="3"
                                :class="$vuetify.breakpoint.mdAndUp ? 'mt-5' : ''"
                            >
                                <v-card-title class="primary--text text-center">
                                    <p>
                                        <b>
                                            Cambiar contraseña
                                        </b>
                                    </p>
                                </v-card-title>
                                <v-card-text class="pb-0" v-if="!success"> 
                                    <v-form id="password-reset-form">
                                    <v-text-field
                                        outlined
                                        :type="showPassword ? 'text' : 'password'"
                                        label="Nueva Contraseña"
                                        background-color="#FFFFFF"    
                                        prepend-inner-icon="mdi-lock"
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        v-model="password"
                                        @click:append="showPassword = !showPassword"
                                        v-on:keyup.enter="passwordResetKey"
                                    />
                                    <v-text-field
                                        outlined
                                        :type="showPassword2 ? 'text' : 'password'"
                                        label="Repetir Contraseña"
                                        background-color="#FFFFFF"    
                                        prepend-inner-icon="mdi-lock"
                                        :append-icon="showPassword2 ? 'mdi-eye' : 'mdi-eye-off'"
                                        v-model="password2"
                                        @click:append="showPassword2 = !showPassword2"
                                        v-on:keyup.enter="passwordResetKey"
                                    />
                                    <p v-if="error" class="red--text">{{error}}</p>
                                    </v-form>
                                </v-card-text>                                                
                                <v-card-actions class="justify-center my-2 py-0" v-if="!success">
                                    <v-btn large class="px-4 mb-2 primary--text font-weight-bold" color="#FCED4F" :loading='loading' @click="passwordResetKey">
                                        Cambiar Contraseña
                                    </v-btn>
                                </v-card-actions>
                                <v-card-text v-if="success">
                                <strong>Contraseña cambiada con éxito.</strong>
                                </v-card-text>
                                <v-card-actions class="justify-center my-2 py-0">
                                    <router-link :to="{ name: 'login' }">
                                        Inicia sesión 
                                    </router-link>
                                    &nbsp;con tus credenciales 
                                </v-card-actions>
                            </v-card>
                            <v-img src="/auth-form-curve.png" class="signup__form__curve" v-if="$vuetify.breakpoint.mdAndUp" />
                        </div>
                    </v-col>

                </v-row>
            </v-container>
        </section>
        <app-footer-public/>
    </div>
</template>

<script>
  import { mapActions } from "vuex"
  import AppHeaderPublic from "@/components/layout/AppHeaderPublic";
  import AppFooterPublic from "@/components/layout/AppFooterPublic";

  export default {
      name: 'PasswordResetKeyPage',
      components: {
        AppHeaderPublic,
        AppFooterPublic
      },
      data() {
          return {
              uidb36: this.$route.params.uidb36,
              key: this.$route.params.key,
              showPassword: false,
              showPassword2: false,			
              password:'',
              password2: '',
              error: '',
              success: false,
              loading: false,
              domain: window.location.origin
          }
      },   
      methods: {
          isPassCorrect() {
              let isCorrect = true;
              if (this.password.length <= 0 || this.password2.length <= 0) {
                  isCorrect = false;
                  this.error = 'No se han introducido las contraseñas.'
              } else if (this.password.length < 8) {
                  isCorrect = false;
                  this.error = 'La contraseña debe tener un mínimo de 8 caracteres.' 
              } else if (this.password.includes(' ')) {
                  isCorrect = false;
                  this.error = 'La contraseña no puede contener espacios.' 
              } else if (this.password != this.password2) {
                  isCorrect = false;
                  this.error = 'Las contraseñas no coinciden.'
              } 
              return isCorrect;
          },

          async passwordResetKey() {
              if (this.isPassCorrect()) {
                  this.error = ''
                  this.loading = true;
                  try {
                      const resp = await this.passwordResetkeyUser({
                          password: this.password,
                          uidb36: this.uidb36,
                          key: this.key    
                      });
                      console.log(resp);
                      this.loading = false;
                      if ('error' in resp['data']) {
                        this.error = resp['data']['error']
                      }
                      else {
                        this.success = true;                        
                      }                      
                  } catch (error) {
                      this.loading = false;
                      this.error = error.message;
                  }

              }            
          },
          ...mapActions(["passwordResetkeyUser"]), 
      }
  }
</script>

<style scoped>
    .signup__form__column {
        position: relative;
    }
    .signup__form__card {
        z-index: 1;
        font-family: Ubuntu,sans-serif!important;
    }
    .v-text-field--outlined fieldset {
      color: rgba(0, 0, 0, 0) !important;
    }
    p {
        overflow-wrap: normal;
        word-break: normal;
    }
    ul{
        padding: 0px;
    }
    ul > li {
      margin: 0;
      list-style-type: "\003E";
      list-style-position: inside;
    }
    ul > li::marker {
      color: #33ccff;
      font-weight: bold;
    }
    @media screen and (min-width: 600px) {
        .signup__form__curve {
            position: absolute;
            top: -5%;
            left: 50%;
            transform: translate(-50%, 0);
        }
    }
    @media screen and (min-width: 960px) {
        .signup__form__curve {
            top: 0;
            max-width: 490px;
        }
        .signup__background {
            background-image: url('/auth-form-rectangle-bg.png');
            background-position: bottom right;
        }
    }
    .footer  {
      margin-top:0px !important;
    }
    .white_dns {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
